<template>
  <application-layout>
    <v-main>
      <v-container>
        <h1>Manage Default Attributes</h1>

        <unit-attribute-form
          :currentAttributeMap="currentAttributeMap"
          :productTypes="[]"
          :currentFacilityAttribute="currentFacilityAttribute"
          class="mb-5"
          v-if="!loading"
        />

        <v-btn
          data-testid="global-setting-save-attributes-btn"
          class="global-setting-save-attributes-btn ml-0"
          color="primary"
          @click="saveAttributes"
          :disabled="loading"
          :loading="loading"
        >
          Save
        </v-btn>
      </v-container>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import UnitAttributeForm from "@/views/facility/partials/UnitAttributeForm.vue";

export default {
  data() {
    return {
      loading: true,
      currentAttributeMap: null,
      currentFacilityAttribute: 99999999
    };
  },

  methods: {
    saveAttributes() {
      const payload = {
        ident: "global_unit_attribute_map",
        value: JSON.stringify(this.currentAttributeMap)
      };
      this.$store.dispatch("updateGlobalSetting", payload);
    }
  },

  created() {
    this.$store.dispatch("getGlobalSetting", "global_unit_attribute_map")
      .then(resp => {
        this.currentAttributeMap = JSON.parse(resp.data.setting.value);
        this.loading = false;
      });
  },

  components: {
    ApplicationLayout,
    UnitAttributeForm
  }
};
</script>
